"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collapsibleBaseClass = void 0;
var react_1 = __importStar(require("react"));
var context_1 = __importDefault(require("./context"));
var useCollapsibleGroup_1 = __importDefault(require("../../CollapsibleGroup/useCollapsibleGroup"));
exports.collapsibleBaseClass = 'collapsible';
var Collapsible = function (props) {
    var openOnInit = props.openOnInit, classPrefix = props.classPrefix, transTime = props.transTime, transCurve = props.transCurve, children = props.children, onToggle = props.onToggle, openFromProps = props.open, _a = props.initialHeight, initialHeight = _a === void 0 ? 0 : _a, idFromProps = props.id;
    var _b = (0, react_1.useState)(openOnInit), isOpen = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(false), ignoreGroupUpdate = _c[0], setIgnoreGroupUpdate = _c[1];
    var _d = (0, react_1.useState)(0), prevGroupToggleCount = _d[0], setPrevGroupToggleCount = _d[1];
    // NOTE: the 'aria-owns' and 'aria-labelledby' attributes rely on this matching IDs
    var uniqueID = (0, react_1.useId)();
    var id = idFromProps || uniqueID;
    (0, react_1.useEffect)(function () {
        if (openFromProps !== undefined) {
            setIsOpen(openFromProps);
        }
    }, [openFromProps]);
    var _e = (0, useCollapsibleGroup_1.default)(), reportToggleToGroup = _e.reportToggleToGroup, groupToggleCount = _e.toggleCount, groupClassPrefix = _e.classPrefix, groupTransTime = _e.transTime, groupTransCurve = _e.transCurve, allowMultiple = _e.allowMultiple;
    var handleClick = function () {
        if (!allowMultiple && reportToggleToGroup) {
            setIgnoreGroupUpdate(true);
            reportToggleToGroup();
        }
        else
            setIsOpen(!isOpen);
        if (typeof onToggle === 'function')
            onToggle();
    };
    (0, react_1.useEffect)(function () {
        if (groupToggleCount > prevGroupToggleCount) {
            if (!ignoreGroupUpdate)
                setIsOpen(false);
            else {
                setIgnoreGroupUpdate(false);
                setIsOpen(!isOpen);
            }
            setPrevGroupToggleCount(groupToggleCount);
        }
    }, [groupToggleCount, prevGroupToggleCount, isOpen, ignoreGroupUpdate]);
    var prefixToUse = classPrefix || groupClassPrefix;
    var context = {
        classPrefix: classPrefix,
        rootClass: prefixToUse ? "".concat(prefixToUse, "__").concat(exports.collapsibleBaseClass) : exports.collapsibleBaseClass,
        openOnInit: openOnInit,
        isOpen: isOpen,
        handleClick: handleClick,
        transTime: (typeof transTime === 'number' && transTime) || (typeof groupTransTime === 'number' && groupTransTime) || 0,
        transCurve: transCurve || groupTransCurve,
        onToggle: onToggle,
        initialHeight: initialHeight,
        id: id
    };
    return (react_1.default.createElement(context_1.default.Provider, { value: context }, (children && (typeof children === 'function' ? children(__assign({}, context)) : children)) || null));
};
exports.default = Collapsible;
//# sourceMappingURL=index.js.map